export const whatsappService = {
    /**
     * Envoyer un message + PDF via API backend
     */
    async sendWhatsAppMessageWithPDF(phoneNumber, message, pdfBase64, fileName) {
        try {

            const formattedPhone = this.formatPhoneNumber(phoneNumber);
            const apiBaseUrl = (process.env.REACT_APP_WHATSAPP_API_BASE_URL || '').trim();
            const isLocalhost = typeof window !== 'undefined' && window.location.hostname === 'localhost';
            const endpoint = isLocalhost
                ? '/api/whatsapp'
                : apiBaseUrl
                    ? `${apiBaseUrl.replace(/\/$/, '')}/api/whatsapp`
                    : '/api/whatsapp';

            // Appel à l'API Vercel
            const response = await fetch(endpoint, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    phoneNumber: formattedPhone,
                    message: message,
                    pdfBase64: pdfBase64,
                    fileName: fileName,
                }),
            });

            if (!response.ok) {
                const contentType = response.headers.get('content-type') || '';

                if (contentType.includes('application/json')) {
                    const error = await response.json();
                    throw new Error(error.error || 'Erreur envoi WhatsApp');
                }

                const errorText = await response.text();
                throw new Error(
                    `Erreur envoi WhatsApp (${response.status}): ${errorText.slice(0, 160)}`
                );
            }

            const contentType = response.headers.get('content-type') || '';
            if (contentType.includes('application/json')) {
                await response.json();
            }

            return true;
        } catch (error) {
            console.error('[whatsappService] Erreur:', error);
            throw error;
        }
    },

    /**
     * Formater le numéro de téléphone
     */
    formatPhoneNumber(phone) {
        if (!phone) return '';

        const original = String(phone).trim();
        let cleaned = original.replace(/\D/g, '');

        if (original.startsWith('+')) {
            return cleaned;
        }

        if (cleaned.startsWith('00')) {
            cleaned = cleaned.substring(2);

            return cleaned;
        }

        if (cleaned.startsWith('0')) {
            cleaned = '33' + cleaned.substring(1);

            return cleaned;
        }

        return cleaned;
    },

    /**
     * Ouvre WhatsApp avec un message pré-rempli
     */
    openWhatsApp(phoneNumber, message, existingWindow = null) {
        const formattedPhone = this.formatPhoneNumber(phoneNumber);

        if (!formattedPhone) {
            throw new Error('Numéro de téléphone invalide');
        }

        const encodedMessage = encodeURIComponent(message || '');
        const whatsappUrl = `https://wa.me/${formattedPhone}?text=${encodedMessage}`;

        if (existingWindow && !existingWindow.closed) {
            existingWindow.location.href = whatsappUrl;
            existingWindow.focus();
            return true;
        }

        const popup = window.open(whatsappUrl, '_blank');
        if (!popup) {
            // Fallback si popup bloquée
            window.location.href = whatsappUrl;
        }

        return true;
    },
};
